import { render, staticRenderFns } from "./Show.vue?vue&type=template&id=4bbbcd3c&scoped=true&"
import script from "./Show.vue?vue&type=script&lang=ts&"
export * from "./Show.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbbcd3c",
  null
  
)

export default component.exports